<template>
    <section class="abs" style="top: 0px; right: 0px;">
        <div id="contentMenu" style="width: 300px">
            <div id="searchInputWrapper" class="flexContainer ai-c jc-sb">
                <input id="searchInput" class="full" type="search" :placeholder="$t('common.search')" />
                <div class="ai-c"><img id="cross" src="../assets/cross.png" alt width="10" height="10" class="cross pointer" /></div>
                <div class="ai-c">
                    <router-link to="#"> <img id="glass" src="../assets/loupe.png" /> </router-link>
                </div>
            </div>
            <section id="content">
                <transition-group name="fade" id="resultsWrapper" class="flexContainer fw-w scrollY rel">
                    <div v-for="item in elements" :key="item.id" class="item rel size1of3 flexContainer fd-c ai-c jc-fs">
                        <div class="item full center txtCenter">
                            <figure class="rel center">
                                <img
                                    src="../../static/img/no_image.jpg"
                                    class="grab img-fluid ff-medium svgMeuble center"
                                    v-if="item.figures.medium === null"
                                />
                                <img
                                    :src="getImgPath(item, 'medium')"
                                    class="grab img-fluid ff-medium svgMeuble center"
                                    v-if="item.hasOwnProperty('figures') && item.figures.medium !== null"
                                />
                            </figure>
                            <div class="flexContainer">
                                <h4 class="ff-bold rel capitalize jc-sb center txtCenter">{{ item.terms.name[$t("trad")]["value"] }}</h4>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </section>
        </div>
    </section>
</template>
<script>
import { mapGetters } from "vuex";
import Globals from "./globals.js";

export default {
    components: {},
    data: () => ({
        elements: {}
    }),
    watch: {},
    methods: {
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath.figures.big;
        }
    },
    computed: {
        ...mapGetters({
            getElementItems: "items/getElementItems"
        })
    },
    created() {
        this.$store.dispatch("items/getElementItems", { carcass: 0, cluster: 1, plano: 0 }).then(response => {
            this.elements = response;
        });
    }
};
</script>
<style lang="scss" scoped>
.goToCatalogue {
    text-decoration: none;
    color: #000;
    margin: auto;
    font-size: 14px;
    border: 1px solid #cfcfcf;
    padding: 10px 15px;
    .link {
        margin-right: 6px;
    }
}

#contentMenu {
    background: #fff;
    height: calc(100vh - 176px);
    #searchInputWrapper {
        padding: 15px;
        #searchInput {
            height: 30px;
            border-left: none;
            border-top: none;
            border-right: none;
            font-size: 14px;
        }
        #cross {
            position: relative;
            right: 15px;
        }
    }
    #filtersPlano {
        padding: 0 15px;
        .sections {
            padding-left: 0;
            margin-top: 0;
            li {
                background-color: #eeeeee;
                padding: 10px 15px;
                font-size: 14px;
                margin-right: 15px;
                &.active {
                    background-color: #41b4e8;
                    color: #fff;
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: -6px;
                        width: 0px;
                        height: 0px;
                        border-left: 7px solid transparent;
                        border-right: 7px solid transparent;
                        border-top: 7px solid #41b4e8;
                    }
                    &:last-child {
                        margin-right: 15px;
                    }
                }
                &.goToCatalogue {
                    background: #fff;
                }
            }
        }
        .categories {
            padding-left: 0;
            margin-top: 20px;
            li {
                padding: 0 10px;
                font-size: 14px;
                color: #aaa;
                &.active {
                    color: #41b4e8;
                }
            }
        }
        .subCategories {
            padding-left: 0;
            margin-top: 15px;
            li {
                padding: 0 10px;
                color: #aaa;
                font-size: 12px;
                &.active {
                    color: #41b4e8;
                }
            }
        }
    }
    #spinnerLoader {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        z-index: 10;
        .loader {
            margin: auto;
        }
    }
    #content {
        height: 100%;
    }
    #noResults {
        height: calc(100vh - 365px);
        h3 {
            margin: auto;
        }
    }
    #resultsWrapper {
        padding: 15px 15px 0px 15px;
        max-height: calc(100vh - 365px);
        .item {
            font-size: 12px;
            margin-bottom: 20px;
            .item {
                margin-bottom: 0;
                img {
                    top: 0;
                    right: 10px;
                }
            }
            &.bordered {
                border-right: 1px solid #ccc;
            }
            .svgMeuble {
                padding: 15px;
                width: 200px;
                height: 200px;
            }
            h3 {
                padding: 0 15px;
                margin: 0;
                a {
                    text-decoration: none;
                    color: #343434;
                }
            }
            figure {
                max-width: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    #contentMenu {
        #filtersPlano {
            .sections {
                li {
                    font-size: 1.1rem;
                    padding: 5px 7px;
                    height: 25px;
                    line-height: 15px;
                    img {
                        width: 10px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Element.vue?143871b4